import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@angular/router";
import * as i3 from "@fortawesome/angular-fontawesome";
import * as i4 from "@progress/kendo-angular-navigation";
function ContentLinkHeaderComponent_h1_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h1");
    i0.ɵɵelement(1, "i", 6);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 7);
    i0.ɵɵprojection(5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.title);
  }
}
function ContentLinkHeaderComponent_ng_template_5_a_0_fa_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 12);
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("icon", item_r2.icon);
  }
}
const _c0 = function (a0) {
  return [a0];
};
function ContentLinkHeaderComponent_ng_template_5_a_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 10);
    i0.ɵɵtemplate(1, ContentLinkHeaderComponent_ng_template_5_a_0_fa_icon_1_Template, 1, 1, "fa-icon", 11);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(5, _c0, item_r2.route));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r2.icon);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("\u00A0", i0.ɵɵpipeBind1(4, 3, item_r2.title), "");
  }
}
function ContentLinkHeaderComponent_ng_template_5_span_1_fa_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 12);
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("icon", item_r2.icon);
  }
}
function ContentLinkHeaderComponent_ng_template_5_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtemplate(1, ContentLinkHeaderComponent_ng_template_5_span_1_fa_icon_1_Template, 1, 1, "fa-icon", 11);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r2.icon);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("\u00A0", i0.ɵɵpipeBind1(4, 2, item_r2.title), "");
  }
}
function ContentLinkHeaderComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ContentLinkHeaderComponent_ng_template_5_a_0_Template, 5, 7, "a", 8);
    i0.ɵɵtemplate(1, ContentLinkHeaderComponent_ng_template_5_span_1_Template, 5, 4, "span", 9);
  }
  if (rf & 2) {
    const item_r2 = ctx.$implicit;
    i0.ɵɵproperty("ngIf", item_r2.route);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !item_r2.route);
  }
}
const _c1 = function (a0) {
  return {
    "header-padding": a0
  };
};
const _c2 = ["*"];
export class ContentLinkHeaderComponent {
  constructor() {
    this.compacted = false;
  }
  onItemClick(event) {}
}
ContentLinkHeaderComponent.ɵfac = function ContentLinkHeaderComponent_Factory(t) {
  return new (t || ContentLinkHeaderComponent)();
};
ContentLinkHeaderComponent.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
  type: ContentLinkHeaderComponent,
  selectors: [["app-content-link-header"]],
  inputs: {
    title: "title",
    breadcrumb: "breadcrumb",
    compacted: "compacted"
  },
  ngContentSelectors: _c2,
  decls: 6,
  vars: 5,
  consts: [[1, "row", "mb-3"], [1, "col"], [1, "content-header", 3, "ngClass"], [4, "ngIf"], [3, "items", "itemClick"], ["kendoBreadCrumbItemTemplate", ""], [2, "margin-left", "-10px", "font-size", "20px", "padding-right", "10px"], [1, "ml-2"], ["class", "k-cursor-pointer k-flex-none k-breadcrumb-link", 3, "routerLink", 4, "ngIf"], ["class", "k-cursor-pointer k-flex-none k-breadcrumb-link k-state-disabled", 4, "ngIf"], [1, "k-cursor-pointer", "k-flex-none", "k-breadcrumb-link", 3, "routerLink"], [3, "icon", 4, "ngIf"], [3, "icon"], [1, "k-cursor-pointer", "k-flex-none", "k-breadcrumb-link", "k-state-disabled"]],
  template: function ContentLinkHeaderComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "section", 2);
      i0.ɵɵtemplate(3, ContentLinkHeaderComponent_h1_3_Template, 6, 1, "h1", 3);
      i0.ɵɵelementStart(4, "kendo-breadcrumb", 4);
      i0.ɵɵlistener("itemClick", function ContentLinkHeaderComponent_Template_kendo_breadcrumb_itemClick_4_listener($event) {
        return ctx.onItemClick($event);
      });
      i0.ɵɵtemplate(5, ContentLinkHeaderComponent_ng_template_5_Template, 2, 2, "ng-template", 5);
      i0.ɵɵelementEnd()()()();
    }
    if (rf & 2) {
      i0.ɵɵadvance(2);
      i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c1, !ctx.compacted));
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.title);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("items", ctx.breadcrumb);
    }
  },
  dependencies: [i1.NgClass, i1.NgIf, i2.RouterLink, i3.FaIconComponent, i4.BreadCrumbComponent, i4.BreadCrumbItemTemplateDirective, i1.AsyncPipe],
  styles: ["@charset \"UTF-8\";\nfa-icon[_ngcontent-%COMP%] {\n  width: 20px;\n  text-align: center;\n  display: inline-block;\n}\n\n.k-breadcrumb[_ngcontent-%COMP%]   .k-breadcrumb-link[_ngcontent-%COMP%], .k-breadcrumb[_ngcontent-%COMP%]   .k-breadcrumb-link[_ngcontent-%COMP%] {\n  color: #333;\n}\n\n.k-breadcrumb[_ngcontent-%COMP%]   .k-breadcrumb-link[_ngcontent-%COMP%]:hover, .k-breadcrumb[_ngcontent-%COMP%]   .k-breadcrumb-link.k-state-hover[_ngcontent-%COMP%] {\n  color: #007bff;\n  background-color: inherit !important;\n}\n\n.content-header[_ngcontent-%COMP%] {\n  position: relative;\n}\n.content-header[_ngcontent-%COMP%]    > h1[_ngcontent-%COMP%] {\n  margin: 0;\n  font-size: 24px;\n}\n.content-header[_ngcontent-%COMP%]    > h1[_ngcontent-%COMP%]    > small[_ngcontent-%COMP%] {\n  font-size: 15px;\n  display: inline-block;\n  padding-left: 4px;\n  font-weight: 300;\n}\n.content-header[_ngcontent-%COMP%]    > .breadcrumb[_ngcontent-%COMP%] {\n  background: transparent;\n  margin-top: 0;\n  margin-bottom: 0;\n  font-size: 12px;\n  top: 15px;\n  right: 10px;\n  float: none;\n  padding: 5px 0px;\n  position: unset;\n}\n.content-header[_ngcontent-%COMP%]    > .breadcrumb[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%], .content-header[_ngcontent-%COMP%]    > .breadcrumb[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > span[_ngcontent-%COMP%] {\n  color: #444;\n  text-decoration: none;\n  display: inline-block;\n}\n.content-header[_ngcontent-%COMP%]    > .breadcrumb[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]    > .fa[_ngcontent-%COMP%], .content-header[_ngcontent-%COMP%]    > .breadcrumb[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]    > .glyphicon[_ngcontent-%COMP%], .content-header[_ngcontent-%COMP%]    > .breadcrumb[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%]    > .ion[_ngcontent-%COMP%], .content-header[_ngcontent-%COMP%]    > .breadcrumb[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > span[_ngcontent-%COMP%]    > .fa[_ngcontent-%COMP%], .content-header[_ngcontent-%COMP%]    > .breadcrumb[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > span[_ngcontent-%COMP%]    > .glyphicon[_ngcontent-%COMP%], .content-header[_ngcontent-%COMP%]    > .breadcrumb[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > span[_ngcontent-%COMP%]    > .ion[_ngcontent-%COMP%] {\n  margin-right: 5px;\n}\n.content-header[_ngcontent-%COMP%]    > .breadcrumb[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    + li[_ngcontent-%COMP%]:before {\n  content: \">\u00A0\";\n}\n\n.header-padding[_ngcontent-%COMP%] {\n  padding-top: 10px;\n}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"],
  changeDetection: 0
});